import helpers from '../helpers';
import Screen from '../modules/home/screen';

let defaultScreen = null;
let promoScreen = null;
let screens = [];

let screenCount = $('.text-blocks .text-blocks__item').length;
let currentScreen = null;
let currentScreenIndex = -1;
// function getRandom() {
// 	return Math.floor(Math.random() * screenCount);
// }
function reset() {
	defaultScreen = null;
	promoScreen = null;
	screens = [];
	screenCount = $('.text-blocks .text-blocks__item').length;
	currentScreen = null;
	currentScreenIndex = -1;
}

function init() {
	if (!screenCount) {
		return false;
	}

	defaultScreen = new Screen('default');
	promoScreen = new Screen('promo');

	for (let i = 0; i < screenCount; i++) {
		screens.push(new Screen(i));
	}

	defaultScreen.fadeIn();
	currentScreen = defaultScreen;

	return true;
}

function next() {
	currentScreen.fadeOut().then(() => {
		currentScreenIndex++;
		if (currentScreenIndex >= screenCount) {
			promoScreen.fadeIn();
			currentScreen = promoScreen;
		} else {
			screens[currentScreenIndex].fadeIn();
			currentScreen = screens[currentScreenIndex];
		}
		if (currentScreen.id !== 'default') {
			$('.back-link').removeClass('is-hide');
		} else {
			$('.back-link').addClass('is-hide');
		}
	});
}

$(document).on('click', '.js-cards-next', (e) => {
	if ($(e.currentTarget).hasClass('js-analytics-next')) {
		const name = $(e.currentTarget).closest('.text-blocks__item').find('.home__title').text();

		helpers.$document.trigger('action-next-card', name);
	}
	next();
});

$(document).on('click', '.back-link', () => {
	currentScreen.fadeOut().then(() => {
		defaultScreen.fadeIn();
		currentScreen = defaultScreen;
		currentScreenIndex = -1;
		$('.back-link').addClass('is-hide');
	});
});

$(document).on('click', '.js-name-open', function (e) {
	e.stopPropagation();

	if (!$(e.currentTarget).hasClass('is-open')) {
		const name = $(e.currentTarget).closest('.text-blocks__item').find('.home__title').text();
		helpers.$document.trigger('action-show-name', name);
	}

	if ($(document).width() > 1024) {
		$(this).addClass('is-open');
	} else {
		const id = $(this).data('name');
		$(`#popup-name-${id}`).addClass('is-active');
	}
});

$(document).on('click', '.js-name-close', function (e) {
	e.stopPropagation();
	$(this).closest('.btn-link__showName').removeClass('is-open');
});

$(document).on('click', '.popup__close', (e) => {
	$(e.currentTarget).closest('.popup').removeClass('is-active');
});

$(document).on('click', () => {
	$('.popup').removeClass('is-active');
});

$(document).on('click', '.popup__body', (e) => {
	e.stopPropagation();
});
// function destroy(container) {
// 	$(container).find('.category-item').off('.home');
// 	$(container).find('.home__image').off('.home');
// }

export default {
	init,
	reset,
	// destroy,
};
